<template>
  <div class="flex-1_3 podcast-container podcast-container-accesibilidad">
    <div class="podcast-content a11y-ocultar-imagen-link">
      <picture class="picture picture-podcast imagen">
        <source :srcset="require('@/assets/img/acciones/portadas_version_escritorio/' + imagen_lap)" media="(min-width: 769px)" />
        <img :srcset="require('@/assets/img/acciones/' + imagen_cel)" alt="" />
      </picture>
      <p class="p-x-1">
        <strong>{{ titulo }}</strong>
      </p>
      <p class="descripcion p-x-1">{{ descripcion }}</p>
    </div>
    <div class="podcast-bottom">
      <div class="leer-mas">
        <button
          class="boton-leer-mas"
          type="button"
          @click="$modal.show(identificador); mostrarModal(true);"
          >
          Leer más
        </button>
      </div>
      <div class="casa-enlace a11y-ocultar-imagen-link">
        <div class="casa-flex">
          <p class="casa-texto">{{status}}</p>
          <p class="font-w">{{ status_cantidad }}</p>
        </div>
      </div>
    </div>
    <modal
      :adaptative="true"
      height="auto"
      :width="588"
      :shiftY="0.65"
      class="modal-contenido marginTop show-modal m-t-1"
      v-bind:name="identificador"
      >
      <!-- <div class="cerrar-modal" @click="$modal.hide(identificador)">X</div> -->
      <picture class="picture picture-podcast modal-show">
        <!-- <source :srcset="require('@/assets/img/acciones/portadas_cortas/' + imagen_lap)" media="(min-width: 769px)" /> -->
        <source :srcset="require('@/assets/img/acciones/portadas_version_escritorio/' + imagen_lap)" media="(min-width: 769px)" />
        <img :srcset="require('@/assets/img/acciones/' + imagen_cel)" alt="" />
      </picture>
      <div class="cerrar-modal" @click="$modal.hide(identificador); mostrarModal(false)">X</div>
      <div class="list-container">
        <p class="p-modal font-style-1">{{ titulo }}</p>
        <p class="p-modal font-style-3">{{ status }} {{ status_cantidad }}</p>
        <p class="p-modal">{{ descripcion }}</p>
        <div class="pleca-acciones-conacyt">
          <p class="p-modal font-style-1">Acciones Conahcyt</p>
          <p v-html="acciones_conacyt" class="p-modal"></p>
        </div>
        <div v-if="acciones_admin_pub_fed">
          <p class="p-modal font-style-2">Acciones de la Administración Pública Federal</p>
          <p class="p-modal">{{ acciones_admin_pub_fed }}</p>
        </div>
        <p class="p-modal font-style-1">Acciones para atender el sargazo</p>
        <div class="lista-texto-modal">

          <ListadoAcciones
            :titulo="titulo"
            :lista="require('@/assets/data/lista_acciones.json')"
          />

        </div>
        <div v-if="info_complementaria">
          <p class="p-modal font-style-2">Información complementaria</p>
          <div v-html="reemplazarTextoCDN(info_complementaria)" class="p-modal word-wrap-anywhere"></div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ListadoAcciones from "@/components/utiles/ListadoAcciones";
import { mapGetters } from "vuex";

export default {
  name: "TarjetaAcciones",
  props: {
    titulo: {
      type: String,
      default: "Título del Podcast",
    },
    descripcion: {
      type: String,
      default: "Descripción del Podcsast",
    },
    acciones_conacyt: {
      type: String,
      default: "Acciones Conahcyt",
    },
    acciones_admin_pub_fed: {
      type: String,
      default: "Acciones de la Administración Pública Federal",
    },
    info_complementaria: {
      type: String,
      default: () => "",
    },
    status: {
      type: String,
      default: "Sin información",
    },
    status_cantidad: {
      type: String,
      default: "Sin información",
    },
    imagen_lap: String,
    imagen_cel: String,
    card_imagen: {
      type: String,
      default: "card_default.jpg",
    },
    identificador: {
      type: String,
    }
  },
  computed: {
    ...mapGetters(["cdnArchivosSargazo"]),
  },
  methods: {
    mostrarModal(abierto) {
      if(abierto) {
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.position = 'inherit';
        if(window.innerWidth <= 375){
          window.scrollTo(0,1600);
        } else {
          window.scrollTo(0,850);
        }
      }
    },
    reemplazarTextoCDN(texto) {
      return texto.replaceAll("${cdnArchivosSargazo}", this.cdnArchivosSargazo)
    },
  },
  components: {
    ListadoAcciones,
  }
};
</script>

<style lang="scss">
.word-wrap-anywhere {
  word-wrap: anywhere;
}
.p-x-1 {
  padding: 0 8px;
}
.p-modal {
  padding: 0 $gap;
  &.font-style-1 {
    font-size: 24px;
    font-weight: 500;
  }
  &.font-style-2 {
    font-size: 16px;
    font-weight: 600;
  }
  &.font-style-3 {
    color:#6F7271;
    font-size: 16px;
    font-weight: 400;
  }
}
img {
  max-width: 100%;
}
.link-podcast {
  color: #141414;
  &:hover {
    cursor: pointer;
    color: #141414;
  }
}
.casa-texto {
  font-weight: 500;
}
.enlace {
  &:hover {
    filter: invert(30%) sepia(54%) saturate(2135%) hue-rotate(315deg)
      brightness(89%) contrast(93%);
  }
}
.podcast-container {
  display: flex;
  flex-direction: column;
  margin-bottom: $gap;
  height: auto;
  border-radius: 10px;
  box-shadow: 2px 2px 10px #00000029;
  overflow: hidden;
  .picture-podcast {
    display: block;
    height: 187px;
    overflow: hidden;
    a {
      width: 100%;
    }
    img {
      width: 100%;
      border-radius: 10px 0 0 0;
    }
    &.modal-show {
      position: absolute;
    }
  }
  .podcast-content {
    flex: 2;
  }
  .podcast-bottom {
    flex-shrink: 0;
  }
  &:hover {
    box-shadow: 5px 5px 10px #00000029;
  }
  &:active {
    border: 1px solid #4589fc;
    box-shadow: 1px 1px 10px 1px #4589fc;
  }
  .casa-enlace {
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
    bottom: 0;
    .casa-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .casa-texto {
        min-width: 50%;
        padding: 0;
      }
      .font-w {
        font-weight: 500;
      }
    }
  }
  .casa-enlace-modal {
    padding: 0 $gap;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .casa-texto-modal, .status-texto-modal {
      padding: 0;
      font-weight: 600;
    }
  }
  .descripcion {
    max-height: 105px;
    overflow: hidden;
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      // max-height: 100%;
    }
  }
  .leer-mas {
    padding: 8px 8px;
    bottom: calc(12% - #{$gap * 0.5});
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      // display: none;
    }
    .boton-leer-mas {
      border: 1px solid #9d4637;
      background: #9d4637;
      color: white;
      font-weight: 400;
      &:hover {
        box-shadow: 2px 2px 10px #00000029;
      }
    }
  }
}
@media (min-width: map-get($media-queries-limit, "mobile")) {
  .flex-1_3 {
    flex: 1 0 33%;
    max-width: calc(33% - #{$gap * 0.5});
    margin-bottom: $gap;
  }
}
.marginTop {
  .vm--modal {
    width: 315px !important;
    height: 600px !important;
    top: 130px !important;
    left: calc(50% - 157.5px) !important;
    // margin-bottom: 160px !important;
    border-radius: 13px;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      width: 1024px !important;
      height: 700px !important;
      top: 100px !important;
      left: calc(50% - 512px) !important;
      margin-bottom: 140px !important;
    }
  }
}
.modal-contenido {
  border-radius: 10px;
  overflow-y: scroll;
  font-size: 15px;
  font-size: 16px;
  .cerrar-modal {
    // position: absolute;
    position:relative;
    top: $gap * 0.5;
    right: $gap * 0.5;
    font-size: 22px;
    font-weight: bold;
    text-align: right;
    line-height: 40px;
    color: white;
    // width: 40px;
    height: 40px;
    overflow: hidden;
    cursor: pointer;
  }
  .list-container {
    cursor: all-scroll;
    position: relative;
    height: 390px;
    overflow: scroll;
    top: 131px;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      top: 147px;
      height: 492px;
    }
    /* &:hover {
      // background: #F5F5F5;
    } */
    .pleca-acciones-conacyt {
      background-color: #002663;
      color: #fff;
      padding: 1px 0px;
    }
  }
}
</style>
